import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IDownloadManagerService } from '../../../../../core/services/download-manager.service';
import { IMenuItemClass } from '../../../../../core/services/menu/menu-item.service';
import { IStateParamsService } from 'angular-ui-router';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';

interface IPageAs0049 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function As0049Controller(
    as0048Route: IRoute,
    Menu: IMenuClass,
    MenuItemForage: IMenuItemForageClass,
    MenuItem: IMenuItemClass,
    downloadManager: IDownloadManagerService,
    $stateParams: IStateParamsService,
    ecranDetails: IEcranDetailsResourcesEntite,
) {
    const vm: IPageAs0049 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false
        },
        navigatePage: as0048Route.NAME,
        actionsMore: new Menu([
            new MenuItem('TELECHARGER_PATRON', () => {
                downloadManager.directDownload('/as0049/patron', {}, $stateParams, ecranDetails);
            }, {
                icon: 'file_download'
            })
        ]),
        actionsNouveaux: new Menu([
            new MenuItemForage(as0048Route.NAME)
        ]),
        colonnesVisibles: [
            { nom: 'ftinumcha', largeur: 136 },
            { nom: 'ftificsou', largeur: 200 },
            { nom: 'datcre', largeur: 110 },
            { nom: 'usrnom', largeur: 180 },
            { nom: 'ftinbrlig', largeur: 120 },
            { nom: 'ftinbrerr', largeur: 120 },
            { nom: 'ftinbrsansaft', largeur: 120 },
            { nom: 'ftinbravecaft', largeur: 120 },
            { nom: 'ftiflgval', largeur: 126 },
            { nom: 'ftiflggen', largeur: 126 }
        ],
        colonnesCachees: ['fticleint']
    };
}
